import React, { useState } from 'react'
import AiQuizForm from './AiQuizForm'
import AiQuizCreation from './AiQuizCreation'

const quizParams = {
  form: 'quizForm',
  create: 'create'
}

const AiQuizHandler = props => {
  const [selectedParam, setSelectedParam] = useState(quizParams.form)
  const [quizData, setQuizData] = useState(null)

  const { onCancel } = props

  const onQuizData = data => {
    setQuizData(data)
    setSelectedParam(quizParams.create)
  }

  // courses/3656/edit/page-constructor
  // get courseId from props and if it is not present, get it from the url
  const courseId = props.courseId || Number(window.location.pathname.split('/')[2])

  console.log({
    courseId,
    props
  })

  return (
    <>
      {selectedParam === quizParams.form && (
        <AiQuizForm onClose={onCancel} onQuizData={onQuizData} {...props} courseId={courseId} />
      )}

      {selectedParam === quizParams.create && (
        <AiQuizCreation data={quizData} onClose={onCancel} {...props} courseId={courseId} />
      )}
    </>
  )
}

export default AiQuizHandler
